export default [
    {
      path: '/claims',
      name: 'claims',
      component: () => import('@/views/sft/Claims.vue'),
    },
  ]